<template>
  <div>
    <Yukleniyor :data="lo"></Yukleniyor>
    <el-alert
      title="Bakiyesi olan Emanet Ödeme Yok"
      type="success"
      :closable="false"
      v-if="!Emanet && !lo">
    </el-alert>
    <el-table
      class="table-xs"
      style="width: 100%"
      width="100%"
      :data="Emanet"
      v-if="Emanet"
      show-summary
      :height="Height"
      :summary-method="TableFooter"
      @current-change="KisiSecim"
    >
      <el-table-column
        label="Ad Soyad"
        prop="AdSoyad">
      </el-table-column>
      <el-table-column
        width="120"
        align="right"
        prop="Kalan"
        label="Tutar">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import Yukleniyor from "../../../../../Doc/Yukleniyor";

export default {
  components: {Yukleniyor},
  props: ["Bina_id"],
  data() {
    return {
      Height: window.innerHeight - 270,
      Emanet: null,
      AltToplam: 0,
      lo: true
    }
  },
  methods: {
    KisiSecim(val) {
      this.$router.push('/yonetim/kisi/' + val.id);
    },
    SayfaYukle() {
      this.$store.dispatch("Get", {path: 'yonetim/bina/ekran/' + this.Bina_id + '/emanet'})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Emanet = response.Liste
            this.AltToplam = response.AltToplam
            this.lo = false;
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
    },
    TableFooter() {
      const sums = [];
      sums[1] = this.AltToplam;

      return sums;
    },
  },
  created() {
    this.SayfaYukle();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Yonetim/bina/Ekran/Detay/Emanet.vue